import { useContext } from "react";
import { AllContext } from "../constants";
export var useFSConfigJSON = function () {
    var fs_config = useContext(AllContext.GeneralDataContext)[0].fs_config;
    return fs_config;
};
